import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // Only add auth header if user is authenticated via Cognito
  if (!authService.isAuthenticated()) {
    return next(req);
  }

  // Get the auth session and add the ID token to the request
  return from(authService.getAuthSession()).pipe(
    switchMap(session => {
      const idToken = session?.tokens?.idToken?.toString();
      
      if (idToken) {
        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${idToken}`
          }
        });
        return next(authReq);
      }
      
      return next(req);
    })
  );
};
